/**
 * Extract a user-visible message from a thrown value of `unknown` shape.
 *
 * After Phase 5 the codebase gradually moved every `catch (e: any)` to
 * `catch (e: unknown)`. This helper gives `unknown` catch clauses a
 * single, consistent way to read the most common field (`message`)
 * without scattered casts. Use this when you want to surface an error
 * to the user — not for programmatic branching, which should check
 * specific codes/types instead.
 *
 * Priority order:
 *  1. `Error` instance — use `.message`
 *  2. Object with a string `message` — use it
 *  3. Anything else — stringify, fall back to 'unknown error'
 */
export function errorMessage(err: unknown): string {
  if (err instanceof Error) return err.message;
  if (typeof err === 'object' && err !== null && 'message' in err) {
    const m = (err as { message?: unknown }).message;
    if (typeof m === 'string') return m;
  }
  if (err === null || err === undefined) return 'unknown error';
  return String(err);
}
